// import {Link} from 'react-router-dom';

import Card from '@material-tailwind/react/Card';
import CardBody from '@material-tailwind/react/CardBody';
import Button from '@material-tailwind/react/Button';
import Icon from '@material-tailwind/react/Icon';

export default function Legal() {

    return (
        <div className="mt-5">
            <Card className="mb-2 transition cursor-pointer group bg-primary">
                <CardBody>
                    <div className="relative h-5">
                        <div className="inline left">
                            <span className="text-sm text-gray-900 font-light text-white">Terms of Service</span>
                        </div>
                        <Button
                            color=""
                            className="inline float-right -mt-1 group-hover:pl-4"
                            buttonType="link"
                            size="sm"
                            iconOnly
                            rounded
                            ripple="light"
                            onClick={() => {}}
                        >
                                <Icon name="arrow_forward" size="2xl" color="white" />
                        </Button>
                    </div>
                </CardBody>
            </Card>
            <Card className="mb-2 transition cursor-pointer group bg-primary">
                <CardBody>
                    <div className="relative h-5">
                        <div className="inline left">
                            <span className="text-sm text-gray-900 font-light text-white">Privacy Policy</span>
                        </div>
                        <Button
                            color=""
                            className="inline float-right -mt-1 group-hover:pl-4"
                            buttonType="link"
                            size="sm"
                            iconOnly
                            rounded
                            ripple="light"
                            onClick={() => {}}
                        >
                                <Icon name="arrow_forward" size="2xl" color="white" />
                        </Button>
                    </div>
                </CardBody>
            </Card>
            <Card className="mb-2 transition cursor-pointer group bg-primary">
                <CardBody>
                    <div className="relative h-5">
                        <div className="inline left">
                            <span className="text-sm text-gray-900 font-light text-white">Risk disclosure</span>
                        </div>
                        <Button
                            color=""
                            className="inline float-right -mt-1 group-hover:pl-4"
                            buttonType="link"
                            size="sm"
                            iconOnly
                            rounded
                            ripple="light"
                            onClick={() => {}}
                        >
                                <Icon name="arrow_forward" size="2xl" color="white" />
                        </Button>
                    </div>
                </CardBody>
            </Card>
            <Card className="mb-2 transition cursor-pointer group bg-primary">
                <CardBody>
                    <div className="relative h-5">
                        <div className="inline left">
                            <span className="text-sm text-gray-900 font-light text-white">Cookie Policy</span>
                        </div>
                        <Button
                            color=""
                            className="inline float-right -mt-1 group-hover:pl-4"
                            buttonType="link"
                            size="sm"
                            iconOnly
                            rounded
                            ripple="light"
                            onClick={() => {}}
                        >
                                <Icon name="arrow_forward" size="2xl" color="white" />
                        </Button>
                    </div>
                </CardBody>
            </Card>
            <Card className="mb-2 transition cursor-pointer group bg-primary">
                <CardBody>
                    <div className="relative h-5">
                        <div className="inline left">
                            <span className="text-sm text-gray-900 font-light text-white">Disclaimers</span>
                        </div>
                        <Button
                            color=""
                            className="inline float-right -mt-1 group-hover:pl-4"
                            buttonType="link"
                            size="sm"
                            iconOnly
                            rounded
                            ripple="light"
                            onClick={() => {}}
                        >
                                <Icon name="arrow_forward" size="2xl" color="white" />
                        </Button>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
}
